import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Visible FAQ block for the SEO landing pages. The same `faq` array is also
 * passed to useSeo, which emits matching FAQPage JSON-LD, so the structured
 * data and the on-page text stay identical (a Google requirement).
 *
 * Any "/become-host" or "/provider/signup" path mentioned in an answer is turned
 * into a real internal link, which doubles as internal-linking SEO without
 * changing the text crawlers match against the schema.
 */
const PATHS = /(\/become-host|\/provider\/signup)/g;

const renderAnswer = (text) =>
  text.split(PATHS).map((part, i) =>
    part === '/become-host' || part === '/provider/signup' ? (
      <Link key={i} to={part} className="text-[#1F3A68] underline">{part}</Link>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );

export default function FaqSection({ faq, title = 'Frequently asked questions' }) {
  if (!faq || !faq.length) return null;
  return (
    <section id="faq" className="max-w-3xl mx-auto px-6 py-8 border-t border-gray-100">
      <h2 className="text-2xl font-bold text-[#1F3A68] mb-4">{title}</h2>
      <div className="space-y-5">
        {faq.map((f) => (
          <div key={f.question}>
            <h3 className="font-bold text-gray-900 mb-1">{f.question}</h3>
            <p className="text-gray-700 leading-relaxed">{renderAnswer(f.answer)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
